import {createMuiTheme} from "@material-ui/core/styles"
import Nuevamente from "./Nuevamente"

export default createMuiTheme(Nuevamente) //Cambiar el Theme Acá. 


// WEBPACK FOOTER //
// ./src/config/Themes/index.js